import { useNestock } from "../contexts/NestockProvider";
import { useAuth } from "../contexts/AuthProvider";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  approvePendingPost,
  createPost,
  createImageOnPost,
} from "../api/PostApi";
import NotFoundPage from "./NotFoundPage";
import FileInput from "../components/FileInput";
import styles from "./PostingPage.module.css";
import pageStyle from "../components/ui/PageBox.module.css";
import classNames from "classnames/bind";

function PostingPage() {
  const { communityList } = useNestock();
  const { setLogOut, user, checkingToken } = useAuth();
  const community = useLocation().state;
  const communities = communityList.map(({ id, communityName }) => ({
    id,
    communityName,
  }));
  communities.unshift({ id: -1, communityName: "커뮤니티" });
  const filteredCommunities =
    user.role !== "ADMIN"
      ? communities
      : communities.filter((commu) => commu.communityName !== "공지"); // 공지 커뮤니티 제외시킴
  const navigate = useNavigate();

  const INITIAL_VALUES = {
    title: "",
    content: "",
    community_id: community ? community.community_id : -1,
  };

  const INITIAL_IMAGE_VALUES = {
    image: null,
  };

  const [values, setValues] = useState(INITIAL_VALUES);
  const [imgValue, setImgValue] = useState(INITIAL_IMAGE_VALUES);

  if (user.id === 0) {
    return (
      <NotFoundPage
        title="게시물을 작성할 수 없습니다"
        description="로그인하시고 이용해주세요"
      />
    );
  }

  const handleSelect = (e) => {
    setValues((prevValues) => ({
      ...prevValues,
      community_id: e.target.value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleImageChange = (value) => {
    setImgValue((prevValues) => ({
      ...prevValues,
      image: value,
    }));
  };

  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    if (values.community_id === -1) {
      alert("업로드할 커뮤니티를 선택해주세요");
      return;
    }
    const {
      code: saveCode,
      data: saveData,
      access_token,
    } = await checkingToken(async (token) => await createPost(values, token));
    if (saveCode < 300) {
      if (imgValue.image) {
        const { code: imgCode } = await createImageOnPost(
          { ...imgValue, post_id: saveData.id },
          access_token
        );
        if (imgCode === 401) {
          setLogOut();
          return;
        } else if (imgCode !== 401 && imgCode >= 300) {
          alert("실패했습니다");
          return;
        }
      }
      const { code, data } = await approvePendingPost(
        {
          post_id: saveData.id,
        },
        access_token
      );
      if (code === 401) {
        setLogOut();
        return;
      } else if (code !== 401 && code >= 300) {
        alert("실패했습니다");
        return;
      } else {
        navigate(`/nest/${data.community_id}/post/${data.id}`);
      }
    }
  };

  return (
    <div className={classNames(styles.container, pageStyle.pageBox)}>
      <h1 className={styles.title}>포스팅</h1>
      <form className={styles.form} onSubmit={handleUploadSubmit}>
        <div className={styles.formGroup}>
          <select
            className={styles.selectType}
            onChange={handleSelect}
            value={values.community_id}
          >
            {filteredCommunities.map((item, idx) => (
              <option key={idx} value={item.id}>
                {item.communityName}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="title" className={styles.label}>
            제목
          </label>
          <input
            type="text"
            name="title"
            className={styles.input}
            required
            placeholder="제목을 입력하세요"
            onChange={handleChange}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="content" className={styles.label}>
            내용
          </label>
          <textarea
            name="content"
            className={styles.textarea}
            required
            placeholder="내용을 입력하세요"
            rows="10"
            onChange={handleChange}
          ></textarea>
        </div>
        <div className={styles.formGroup}>
          <FileInput value={imgValue.image} onChange={handleImageChange} />
        </div>
        {/* <button type="submit" className={styles.button}>
          임시저장
        </button> */}
        <button type="submit" className={styles.button}>
          업로드
        </button>
      </form>
    </div>
  );
}

export default PostingPage;
